// db/feedCacheMaintenance.js

import {
  dbPromise,
  POST_STORE,
  COMMENT_STORE,
  NOTIFICATION_STORE,
} from "./fsDB";

/* =========================================================
   CONFIG
========================================================= */

const MAX_POSTS = 500;

const MAX_NOTIFICATIONS = 100;

/* =========================================================
   INTERNAL LOCKS
========================================================= */

let pruningPosts = false;

let pruningNotifications = false;

/* =========================================================
   PRUNE OLD POSTS + COMMENTS
========================================================= */

export async function pruneOldFeedPosts() {

  if (pruningPosts) return;

  pruningPosts = true;

  try {

    const db = await dbPromise;

    const posts =
      await db.getAll(POST_STORE);

    if (
      posts.length <= MAX_POSTS
    ) {
      return;
    }

    /* ----------------------------------------
       SORT NEWEST FIRST
    ---------------------------------------- */

    const sorted =
      posts.sort((a, b) => {

        const aTime =
          new Date(
            a.updatedAt ||
            a.createdAt ||
            0
          ).getTime();

        const bTime =
          new Date(
            b.updatedAt ||
            b.createdAt ||
            0
          ).getTime();

        return bTime - aTime;

      });

    const overflow =
      sorted.slice(MAX_POSTS);

    const tx = db.transaction(
      [POST_STORE, COMMENT_STORE],
      "readwrite"
    );

    const postStore =
      tx.objectStore(POST_STORE);

    const commentStore =
      tx.objectStore(COMMENT_STORE);

    const commentIndex =
      commentStore.index("postId");

    for (const post of overflow) {

      const postId =
        String(post.postId);

      /* ----------------------------------------
         DELETE POST
      ---------------------------------------- */

      await postStore.delete(postId);

      /* ----------------------------------------
         DELETE RELATED COMMENTS
      ---------------------------------------- */

      const comments =
        await commentIndex.getAll(postId);

      for (const comment of comments) {

        await commentStore.delete(
          comment.commentId
        );

      }

    }

    await tx.done;

  } catch (err) {

  } finally {

    pruningPosts = false;

  }
}

/* =========================================================
   PRUNE OLD NOTIFICATIONS
========================================================= */

export async function pruneOldNotifications() {

  if (pruningNotifications) {
    return;
  }

  pruningNotifications = true;

  try {

    const db = await dbPromise;

    const notifications =
      await db.getAll(
        NOTIFICATION_STORE
      );

    if (
      notifications.length <=
      MAX_NOTIFICATIONS
    ) {
      return;
    }

    const sorted =
      notifications.sort((a, b) => {

        const aTime =
          new Date(
            a.lastActivityAt || 0
          ).getTime();

        const bTime =
          new Date(
            b.lastActivityAt || 0
          ).getTime();

        return bTime - aTime;

      });

    const overflow =
      sorted.slice(
        MAX_NOTIFICATIONS
      );

    const tx = db.transaction(
      [NOTIFICATION_STORE],
      "readwrite"
    );

    const store =
      tx.objectStore(
        NOTIFICATION_STORE
      );

    for (const item of overflow) {

      await store.delete(item.id);

    }

    await tx.done;


  } catch (err) {


  } finally {

    pruningNotifications = false;

  }
}

/* =========================================================
   AUTO MAINTENANCE LOOP
========================================================= */

let started = false;

export function startFeedCacheMaintenance() {

  if (started) return;

  started = true;

  /* ----------------------------------------
     RUN PERIODICALLY
  ---------------------------------------- */

  setInterval(() => {

    pruneOldFeedPosts();

    pruneOldNotifications();

  }, 60 * 1000);

}